import { ValidationRule } from 'vuelidate/lib/validators';

interface EmailValue {
    email: string;
}

export const emailRepeatMustBeIdentical = ((
    value: string,
    vm: EmailValue,
): boolean => {
    return value === vm.email;
}) as ValidationRule;
